import { render, staticRenderFns } from "./sidebarComponent.vue?vue&type=template&id=7362290e&"
import script from "./sidebarComponent.vue?vue&type=script&lang=js&"
export * from "./sidebarComponent.vue?vue&type=script&lang=js&"
import style0 from "./sidebarComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports